import { Button, Chip, Drawer, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { rem } from "assets/js/common";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import Loading from "components/ui/loading";
import PullToRefresh from "react-simple-pull-to-refresh";
import Spinner from "components/ui/spinner";

const useStyles = makeStyles((theme) => ({
  recommendItem: {
    "& .recommend-item": {
      position: "relative",
      padding: `${rem(30)} ${rem(30)} ${rem(20)}`,
      "&:last-of-type": {
        paddingBottom: rem(10),
      },
      "& img": {
        borderRadius: rem(10),
        width: "100%",
      },
      "& .tit": {
        paddingTop: rem(20),
        fontWeight: 700,
      },
      "& .MuiChip-root": {
        position: "absolute",
        top: rem(45),
        left: rem(45),
      },
    },
  },
  detailDrawer: {
    "& .MuiPaper-root ": {
      "& .drawer-head": {
        "& .tit": {
          fontSize: rem(18),
          fontWeight: 800,
          marginTop: rem(12),
        },
      },
      "& .drawer-body": {
        "& img": {
          width: "100%",
        },
        "& .cont": {
          padding: "35px 30px",
          fontSize: rem(15),
          wordBreak: "keep-all",
        },
      },
    },
  },
}));

export default function RecommendItem(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [recommendProductList, setRecommendProductList] = useState([]);
  const [trustDetail, setTrustDetail] = useState(false);
  const [popperData, setPopperData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [pg, setPg] = useState(1);
  const [totalPageSize, setTotalPageSize] = useState("");
  const [title, setTitle] = useState("");
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const fetchData = async () => {
    setFetching(true);
    await axios
      .get("api/eh/recommend-product", { params: { pg: pg, pgSz: 5 } })
      .then((res) => {
        let newList = res.data.data.recommendProductList.list;

        newList.map((item, i) => {
          setValue(`loaded-${item.imgUrl}`, false);
          watch(`loaded-${item.imgUrl}`, false);
        });

        setRecommendProductList(recommendProductList.concat(...newList));
        setTotalPageSize(res.data.data.recommendProductList.totalPageSize);
        setFetching(false);
      })
      .catch((error) => {
        setFetching(false);
      });
    setPg(pg + 1);
  };

  const loadTitle = () => {
    axios.get(`/api/eh/recommend-product/get-title`).then((res) => {
      setTitle(res.data.data.title);
      dispatch(
        loadAction({ back: true, title: res.data.data.title, menu: true })
      );
    });
  };

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init) dispatch(loadAction({ back: true, title: title, menu: true }));
  }, [init]);

  useEffect(() => {
    loadTitle();
    fetchData();
  }, []);

  const handleTrustDetailOpen = async (seq) => {
    setValue("popperData", false);
    watch("popperData", false);
    await axios.get(`/api/eh/recommend-product/get/${seq}`).then((res) => {
      setPopperData(res.data.data.recommendProduct);
    });
    setTrustDetail(true);
  };

  const handleTrustDetailClose = () => {
    setTrustDetail(false);
  };

  const handleScroll = () => {
    const scrollHeight = document.documentElement.scrollHeight;
    const scrollTop = document.documentElement.scrollTop;
    const clientHeight = document.documentElement.clientHeight;
    if (scrollTop + clientHeight >= scrollHeight && fetching === false) {
      if (pg > totalPageSize) return;
      fetchData();
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  window.appBackKeyHandle = () => {
    history.goBack();
  };

  return (
    <>
      <Loading open={fetching} />
      <PullToRefresh
        onRefresh={fetchData}
        pullingContent={false}
        refreshingContent={<Spinner />}
      >
        <main id="main" className={"container " + classes.recommendItem}>
          {!fetching &&
            recommendProductList.map((item, i) => (
              <div
                className="recommend-item"
                key={i}
                onClick={() => {
                  history.push({
                    pathname: `/recommend-item/detail/${item.seq}`,
                    props: { seq: item.seq },
                  });
                }}
              >
                <Chip label={item.catg} />
                <div
                  className="lazy"
                  style={{
                    display:
                      getValues(`loaded-${item.imgUrl}`) === false
                        ? "block"
                        : "none",
                    width: "100%",
                    height: rem(176),
                    borderRadius: "10px",
                    backgroundColor: "#CCCCCC",
                  }}
                />
                <img
                  src={item.imgUrl}
                  onLoad={() => {
                    setValue(`loaded-${item.imgUrl}`, true);
                  }}
                  style={{
                    display:
                      getValues(`loaded-${item.imgUrl}`) === true ? "" : "none",
                  }}
                />
                <div
                  className="tit"
                  dangerouslySetInnerHTML={{
                    __html: item.ttl ? item.ttl : "-",
                  }}
                />
              </div>
            ))}
        </main>
      </PullToRefresh>
    </>
  );
}
